




























// @ts-nocheck
// ^^^^^^^^^^^ Disabled TypeScript linter in this file because it doesn't understand Vue components
// which is not wrapped in Vue.extend(), and we can't use Vue.extend() in Sanity serializers
// because of how src/components/SanityBlockContent.vue initializes the serializers.

export default {
  name: 'SanityLoopvideoSerializer',
  data() {
    return {
      videoId: '',
    };
  },
  computed: {
    autoPlay() {
      return this.autoplay ? 'autoplay' : false;
    },
    muted() {
      return !this.sound;
    },
  },
  props: {
    url: String,
    title: String,
    description: String,
    color: {
      type: String,
      default: () => 'purple',
    },
    showGutter: Boolean,
    autoplay: Boolean,
    sound: Boolean,
    loop: Boolean,
    controls: Boolean,
  },
};
